import { render, staticRenderFns } from "./ApplicationClientDataVerificationPopup.vue?vue&type=template&id=009bce99"
import script from "./ApplicationClientDataVerificationPopup.vue?vue&type=script&lang=ts"
export * from "./ApplicationClientDataVerificationPopup.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationClientDataVerificationPopup.vue?vue&type=style&index=0&id=009bce99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports